import { useTranslation } from "react-i18next";
import { type FC } from "react";
import { PickerBtn } from "./PickerBtn";
import { type ConfigKey, openCountryModal } from "@/modal/openCountryModal";
import { I18nNamespace } from "@/const/i18nNamespace";
import { type RHFField } from "@/common/RHFWrapper";

export const CountryPicker: FC<
  {
    title: string;
    value?: ConfigKey;
    onChange?: (value: ConfigKey) => void;
    disabled?: boolean;
  } & RHFField
> = ({ title, value, onChange, ...props }) => {
  const { t } = useTranslation();

  return (
    <PickerBtn
      label={title}
      value={value ? t(`${I18nNamespace.COUNTRY}:${value}`) : undefined}
      onClick={async () => {
        const { code } = await openCountryModal({
          code: value,
        });
        onChange?.(code);
      }}
      {...props}
    />
  );
};
